import React from "react";
import styles from "./controlUsers.module.scss";
import { DataGrid } from "@mui/x-data-grid";
import clsx from "clsx";
import "./cellTable.css";
import { withUsers } from "../../../shared/containers/containerUsers";
import { dateGridLocalTextOptions } from "../../../shared/services/dataGridLocalTextOptions";

const ControlUsersTable = (props) => {
  const { users, onHandleClick, currentUser } = props;

  const handleEvent = (e) => {
    onHandleClick(e.row.id);
  };

  const styleSelect = (params) => {
    return clsx("inActive-cell", {
      inActive: currentUser !== null && params.id === currentUser.id,
    });
  };

  const styleIsBlocked = (params) => {
    return clsx("inActive-cell", {
      inActiveNegative: params.row.isBlocked,
    });
  };

  const getColumns = () => {
    return [
      {
        field: "email",
        headerName: "Email",
        cellClassName: styleSelect,
        width: 250,
      },
      {
        field: "title",
        headerName: "ФИО",
        cellClassName: styleSelect,
        width: 200,
      },
      {
        field: "roleTitle",
        headerName: "Роль",
        cellClassName: styleSelect,
        width: 150,
      },
      {
        field: "isBlocked",
        headerName: "Заблокирован",
        type: "boolean",
        cellClassName: styleIsBlocked,
        width: 150,
      },
    ];
  };

  return (
    <div className={styles.controlUsersTableContainer}>
      <DataGrid
        onRowClick={handleEvent}
        rowHeight={30}
        disableColumnSelector={true}
        disableColumnFilter={true}
        localeText={{
          ...dateGridLocalTextOptions,
          footerRowSelected: (count) => `Cтрок выбранно: ${count}`,
        }}
        rows={getRows(users)}
        columns={getColumns(onHandleClick)}
        sx={{
          "& .MuiDataGrid-row:hover": {
            cursor: "pointer",
          },
        }}
        disableRowSelectionOnClick
      />
    </div>
  );
};

const getRows = (users) => {
  return users.map((x) => {
    const dateCreation = new Date(Date.parse(x.dateCreation));
    const dateLastSignIn = new Date(Date.parse(x.dateLastSignIn));

    return {
      ...x,
      companyId: x.company.id,
      company: x.company.title,
      roleTitle: x.role.title,
      companyOwnershipArea: x.company.ownershipArea.title,
      dateCreation: new Date(dateCreation.setHours(-new Date().getTimezoneOffset() / 60 + dateCreation.getHours())).toLocaleString(),
      dateLastSignIn: new Date(dateLastSignIn.setHours(-new Date().getTimezoneOffset() / 60 + dateLastSignIn.getHours())).toLocaleString(),
    };
  });
};

export default withUsers(React.memo(ControlUsersTable));
